(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kr-video-stories"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    root.querySelectorAll('.kr-video-stories:not([data-ready])').forEach(function(section){
      section.dataset.ready='true';
      section.querySelectorAll('video').forEach(function(video){video.muted=true;video.defaultMuted=true;video.volume=0;video.controls=false;video.loop=true;video.playsInline=true;video.setAttribute('tabindex','-1');video.setAttribute('disablepictureinpicture','');});
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          var video=entry.target;
          video.dataset.inView=entry.isIntersecting?'true':'false';
          if(entry.isIntersecting&&!document.hidden){video.muted=true;video.play().catch(function(){});}
          else video.pause();
        });
      },{threshold:0.35});
      section.querySelectorAll('video').forEach(function(video){observer.observe(video);});
      document.addEventListener('visibilitychange',function(){
        section.querySelectorAll('video').forEach(function(video){
          if(document.hidden)video.pause();
          else if(video.dataset.inView==='true')video.play().catch(function(){});
        });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
